export const getters = {
    getTransferenciaEstoque: state => state.transferenciaEstoque,
    getTransferenciasEstoques: state => state.transferenciasEstoques,
    getModalCadastroTransferenciaEstoque: state => state.modalCadastroTransferenciaEstoque,
    getModalVisualizarTransferenciaEstoque: state => state.modalVisualizarTransferenciaEstoque,
    getModalExcluirTransferenciaEstoque: state => state.modalExcluirTransferenciaEstoque,
    getItensTransferenciaEstoque: state => state.itensTransferenciaEstoque,
}

export default {}